import CircularProgress from '@material-ui/core/CircularProgress';
import * as React from 'react';
import { ErrorBoundary } from '../components/ErrorBoundary';

interface IHeaderButtonProps {
  children?: React.ReactNode;
}

let HeaderButton: React.FunctionComponent<IHeaderButtonProps> = ({ children }) => {
  if (children) {
    return (
      <ErrorBoundary>
        <React.Suspense fallback={<CircularProgress color="secondary" />}>{children}</React.Suspense>
      </ErrorBoundary>
    );
  }

  return null;
};

HeaderButton = React.memo<IHeaderButtonProps>(HeaderButton);
export { HeaderButton };
